export default {
  name: '場内設備',
  children: [
    { label: 'ワークスペース', value: 'facilities_workspace' },
    { label: 'ドッグラン', value: 'facilities_dogrun' },
    { label: 'レストラン・食堂・カフェ', value: 'facilities_restaurant' },
    { label: '売店・自動販売機', value: 'facilities_store' },
    { label: 'ランドリー', value: 'facilities_laundry' },
  ],
};
